import jssVariables from "../../jss_setup";

export const TransfersSearchStrip = {
  searchStripContainer: {
    background: jssVariables.colors.base_color,

    smallscreen: {
      background: jssVariables.colors.base_color,
    },
  },
  loaderIcon: {
    color: jssVariables.colors.secondary_color,
  },
  loaderText: {
    color: jssVariables.colors.secondary_color,
  },
};

export const TrfSearchStripDest = {
  icon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const TrfSearchStripDate = {
  icon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const TrfSearchStripPax = {
  icon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const TransfersFiltersBar = {
  filtersBar: {
    background: "#8EA2B1",
    smallscreen: {
      color: "white",
    },
  },
};

export const transferStyles = {
  iconFilled: {
    color: jssVariables.colors.secondary_color,
  },
  iconEmpty: {
    color: jssVariables.colors.secondary_color,
  },
  priceComponent: {
    color: jssVariables.colors.secondary_color,
  },
};
